// extracted by mini-css-extract-plugin
export default {"modelDetail__inner":"c-f_eo","modelDetail__top":"c-f_ep","modelDetail__info":"c-f_eq","modelDetail__title":"c-f_er"};